import { getPeer, resetLayers } from "../../../reducers/configurator/utils";
import { countMyDesigns } from "./utils";
import {
  addElement,
  moveElement,
  updateElement,
  updateLastMainVideo,
  updateModalManager,
  updateMultiSelection,
  updateMultiUpload,
  updateSelectedTile,
  updateSpawnWalls,
  updateWalls,
} from "../../../reducers/configurator/configuratorSlice";
import ObjectSideManagement from "../addComponentDialog/ObjectSideManagement";

const handleWalls = (tile, wallOptions, myGrid, parentLayout, dispatch) => {
  if (wallOptions.orientation === "north" && tile.row - 1 >= 0) {
    dispatch(
      updateWalls({
        layer: "walls",
        data: {
          ...myGrid[parentLayout][tile.row - 1][tile.column].walls,
          south: {
            orientation: "south",
            color: wallOptions.color,
          },
          keyName: "south",
        },
        tile: { row: tile.row - 1, column: tile.column },
      })
    );
  } else if (
    wallOptions.orientation === "south" &&
    tile.row + 1 <= myGrid[parentLayout].length - 1
  ) {
    dispatch(
      updateWalls({
        layer: "walls",
        data: {
          ...myGrid[parentLayout][tile.row + 1][tile.column].walls,
          north: {
            orientation: "north",
            color: wallOptions.color,
          },
          keyName: "north",
        },
        tile: { row: tile.row + 1, column: tile.column },
      })
    );
  } else if (wallOptions.orientation === "west" && tile.column - 1 >= 0) {
    dispatch(
      updateWalls({
        layer: "walls",
        data: {
          ...myGrid[parentLayout][tile.row][tile.column - 1].walls,
          east: {
            orientation: "east",
            color: wallOptions.color,
          },
          keyName: "east",
        },
        tile: { row: tile.row, column: tile.column - 1 },
      })
    );
  } else if (
    wallOptions.orientation === "east" &&
    tile.column + 1 <= myGrid[parentLayout][0].length - 1
  ) {
    dispatch(
      updateWalls({
        layer: "walls",
        data: {
          ...myGrid[parentLayout][tile.row][tile.column + 1].walls,
          west: {
            orientation: "west",
            color: wallOptions.color,
          },
          keyName: "west",
        },
        tile: { row: tile.row, column: tile.column + 1 },
      })
    );
  }
};

export const handleTileClick = (
  tile,
  parentLayout,
  currentLayout,
  parentedLayoutsList,
  wallOptions,
  multimode,
  lastMainVideo,
  multiUpload,
  myGrid,
  dispatch,
  t
) => {
  if (currentLayout === "walls" && wallOptions.orientation !== "") {
    dispatch(
      updateWalls({
        layer: "walls",
        data: {
          ...tile.walls,
          [wallOptions.orientation]: {
            orientation: wallOptions.orientation,
            layout: parentLayout,
            color: wallOptions.color,
          },
          keyName: wallOptions.orientation,
        },
        tile: { row: tile.row, column: tile.column },
      })
    );
    handleWalls(tile, wallOptions, myGrid, parentLayout, dispatch);
  }
  if (multimode.active) {
    if (multimode.move) {
      if (multimode.tile) {
        if (
          multimode.data.hasOwnProperty("endTile") &&
          multimode.data.hasOwnProperty("startTile")
        ) {
          //déplacement d'un objet double/complexe
          const tmp = { ...multimode.data };
          if (
            multimode.data.type === "sled" ||
            multimode.data.type === "teqball"
          )
            tmp.peer = getPeer(
              multimode.tile.row,
              multimode.tile.column,
              tile.row,
              tile.column
            );
          if (
            (multimode.data.type === "screen" ||
              multimode.data.type === "ipad") &&
            multimode.data.mainVideo
          ) {
            // update lastMainVideo position in redux
            dispatch(
              updateLastMainVideo({
                layout: multimode.data.layout,
                startTile: multimode.tile,
                endTile: { row: tile.row, column: tile.column },
                data: { ...multimode.data },
              })
            );
          }
          dispatch(
            moveElement({
              oldLayer: multimode.oldLayer,
              layer: multimode.layer,
              data: tmp,
              tile: multimode.data.startTile,
              tileEnd: multimode.data.endTile,
              newTileStart: multimode.tile,
              newTileEnd: { row: tile.row, column: tile.column },
            })
          );
        } else {
          // déplacement d'un objet simple
          if (multimode.data.type === "spawn") {
            dispatch(
              updateSpawnWalls({
                tile: {
                  row: multimode.tile.row,
                  column: multimode.tile.column,
                },
                old: multimode.data.offset,
              })
            );
            dispatch(
              updateSpawnWalls({
                tile: { row: tile.row, column: tile.column },
                direction: multimode.data.offset,
              })
            );
          }
          const tmp = { ...multimode.data };
          if (multimode.data.hasOwnProperty("startTile"))
            tmp.startTile = { row: tile.row, column: tile.column };
          dispatch(
            moveElement({
              oldLayer: multimode.oldLayer,
              layer: multimode.layer,
              data: tmp,
              tile: multimode.tile,
              newTile: { row: tile.row, column: tile.column },
            })
          );
        }
        dispatch(updateMultiSelection(resetLayers.multiSelection));
      } else {
        // selection de la case de départ d'un objet double/complexe
        dispatch(
          updateMultiSelection({
            tile: { row: tile.row, column: tile.column },
          })
        );
      }
    } else if (multimode.associateCoords) {
      dispatch(
        addElement({
          layer: currentLayout === "normal" ? "middle" : currentLayout,
          data: { ...multimode.data },
          tile: { row: multimode.tile.row, column: multimode.tile.column },
          tileEnd: { row: tile.row, column: tile.column },
        })
      );
      dispatch(updateMultiSelection(resetLayers.multiSelection));
    } else if (!multimode.associateCoords && !multimode.unlimited) {
      const tmp = { ...multimode.data };
      if (multimode.data.type === "sled" || multimode.data.type === "teqball")
        tmp.peer = getPeer(
          multimode.tile.row,
          multimode.tile.column,
          tile.row,
          tile.column
        );
      else if (multimode.data.type === "frame") {
        dispatch(
          updateMultiSelection({
            data: {
              ...multimode.data,
              startTile: multimode.tile,
              endTile: { row: tile.row, column: tile.column },
            },
            active: false,
          })
        );
        dispatch(updateModalManager({ open: true }));
      } else {
        // so that's a screen, update the lastMainVideo
        if (multimode.data.mainVideo) {
          let matchingLayoutKey = null;
          Object.keys(parentedLayoutsList).forEach((key) => {
            if (parentedLayoutsList[key].includes(parentLayout))
              matchingLayoutKey = key;
          });
          const existInOld = lastMainVideo.find(
            (item) =>
              item.layout === parentLayout ||
              item.layout === matchingLayoutKey ||
              (parentedLayoutsList.hasOwnProperty(parentLayout) &&
                parentedLayoutsList[parentLayout].includes(item.layout))
          );
          if (existInOld) {
            // exist in same layout
            dispatch(
              updateElement({
                screenOldLayout: existInOld.data.layout,
                layer: existInOld.data.rotation,
                data: { ...existInOld.data, mainVideo: false },
                tile: {
                  row: existInOld.startTile.row,
                  column: existInOld.startTile.column,
                },
                tileEnd: {
                  row: existInOld.endTile.row,
                  column: existInOld.endTile.column,
                },
              })
            );
          }
          dispatch(
            updateLastMainVideo({
              layout: parentLayout,
              startTile: {
                row: multimode.tile.row,
                column: multimode.tile.column,
              },
              endTile: { row: tile.row, column: tile.column },
              data: { ...multimode.data },
            })
          );
        }
      }
      if (multimode.data.type !== "frame") {
        dispatch(
          addElement({
            layer: multimode.layer,
            data: tmp,
            tile: { row: multimode.tile.row, column: multimode.tile.column },
            tileEnd: { row: tile.row, column: tile.column },
          })
        );
        dispatch(updateMultiSelection(resetLayers.multiSelection));
      }
    } else {
      if (
        !(
          multimode.isDelete &&
          tile.middle.type === "arcdetriomphe" &&
          currentLayout === "normal"
        )
      ) {
        if (
          multimode?.tile?.some(
            (item) => item?.row === tile.row && item?.column === tile.column
          )
        ) {
          const newMultiTile = [...multimode.tile];
          newMultiTile.splice(
            newMultiTile.findIndex(
              (item) => item.row === tile.row && item.column === tile.column
            ),
            1
          );
          dispatch(updateMultiSelection({ tile: newMultiTile }));
        } else
          dispatch(
            updateMultiSelection({
              tile: [...multimode.tile, { row: tile.row, column: tile.column }],
            })
          );
      }
    }
  } else if (multiUpload.active) {
    if (multiUpload.activeFile) {
      const tmp = countMyDesigns(tile);
      const { directions, counter } = tmp;
      // if several myDesigns or none => open facade modal
      if (counter > 1 || counter === 0) {
        dispatch(
          updateMultiUpload({
            currentTile: { row: tile.row, column: tile.column },
          })
        );
        dispatch(
          updateModalManager({
            type: "backdrop",
            title: t("configurator.choseFacade"),
            open: true,
            renderer: <ObjectSideManagement isMultiUpload />,
          })
        );
      } else {
        // directly replace the file
        if (tile[directions[0]].size === "custom")
          // case where frame is custom size
          dispatch(
            updateElement({
              layer: directions[0],
              data: { ...tile[directions[0]], file: multiUpload.activeFile },
              tile: {
                row: tile[directions[0]].startTile.row,
                column: tile[directions[0]].startTile.column,
              },
              tileEnd: {
                row: tile[directions[0]].endTile.row,
                column: tile[directions[0]].endTile.column,
              },
            })
          );
        // case where frame is normal size
        else
          dispatch(
            updateElement({
              layer: directions[0],
              data: { ...tile[directions[0]], file: multiUpload.activeFile },
              tile: { row: tile.row, column: tile.column },
            })
          );
        const filteredFiles = multiUpload.files.filter(
          (file) => file.name !== multiUpload.activeFile.name
        );
        dispatch(
          updateMultiUpload({
            files: filteredFiles,
            activeFile: null,
            active: filteredFiles.length === 0 ? false : true,
          })
        );
      }
    }
  } else if (currentLayout !== "walls") {
    dispatch(
      updateSelectedTile({
        row: tile.row,
        column: tile.column,
        // iconUrl: tile.iconUrl,
        // previewUrl: tile.previewUrl,
      })
    );
  }
};

export const isTileAvailableForSpecialObjects = (
  tile,
  row,
  column,
  multimode
) => {
  if (multimode.associateCoords) {
    if (
      (multimode.tile.row + multimode.x === row &&
        multimode.tile.column + multimode.y === column) ||
      (multimode.tile.row - multimode.x === row &&
        multimode.tile.column - multimode.y === column) ||
      (multimode.tile.row - multimode.x === row &&
        multimode.tile.column + multimode.y === column) ||
      (multimode.tile.row + multimode.x === row &&
        multimode.tile.column - multimode.y === column) ||
      (multimode.tile.row + multimode.y === row &&
        multimode.tile.column + multimode.x === column) ||
      (multimode.tile.row - multimode.y === row &&
        multimode.tile.column - multimode.x === column) ||
      (multimode.tile.row - multimode.y === row &&
        multimode.tile.column + multimode.x === column) ||
      (multimode.tile.row + multimode.y === row &&
        multimode.tile.column - multimode.x === column)
    ) {
      return true;
    }
  } else if (!multimode.associateCoords && !multimode.unlimited) {
    if (multimode.move && multimode.x === 0 && multimode.y === 0)
      // move single element
      return true;
    else if (
      multimode.move &&
      !multimode.tile &&
      (multimode.x > 0 || multimode.y > 0)
    ) {
      // move teqball / sled
      return true;
    } else if (
      multimode.move &&
      !multimode.tile &&
      multimode.x < 0 &&
      multimode.y < 0
    ) {
      // move screens
      return true;
    }
    if (
      (!multimode.move || (multimode.move && multimode.tile)) &&
      multimode.x < 0 &&
      multimode.tile.row === row &&
      // multimode.tile.column !== column &&
      (multimode.layer === "north" || multimode.layer === "south")
    ) {
      //place infinite row or move screen with orientation
      return true;
    }
    if (
      (!multimode.move || (multimode.move && multimode.tile)) &&
      multimode.y < 0 &&
      multimode.tile.column === column &&
      // multimode.tile.row !== row &&
      (multimode.layer === "east" || multimode.layer === "west")
    ) {
      // place infinite column or move screen with orientation
      return true;
    }
    if (
      (!multimode.move || (multimode.move && multimode.tile)) &&
      multimode.x > 0 &&
      (row === multimode.tile.row - multimode.x ||
        row === multimode.tile.row + multimode.x) &&
      (!multimode.data.hasOwnProperty("rotation") ||
        multimode.data.rotation === "east" ||
        multimode.data.rotation === "west")
    ) {
      if (
        (multimode.tile.row + multimode.x === row &&
          multimode.tile.column === column) ||
        (multimode.tile.row - multimode.x === row &&
          multimode.tile.column === column)
      ) {
        return true;
      }
    }
    if (
      (!multimode.move || (multimode.move && multimode.tile)) &&
      multimode.y > 0 &&
      (column === multimode.tile.column - multimode.y ||
        column === multimode.tile.column + multimode.y) &&
      (!multimode.data.hasOwnProperty("rotation") ||
        multimode.data.rotation === "north" ||
        multimode.data.rotation === "south")
    ) {
      if (
        (multimode.tile.row === row &&
          multimode.tile.column + multimode.y === column) ||
        (multimode.tile.row === row &&
          multimode.tile.column - multimode.y === column)
      ) {
        return true;
      }
    }
  } else if (multimode.unlimited) {
    if (tile.middle.type === "spawn") return false;
    return true;
  }
  return false;
};

export function getTileStyle(
  tile,
  row,
  column,
  rowNumber,
  columnNumber,
  multimode,
  classes,
  selectedTile,
  currentLayout,
  isAvailable,
  width
) {
  // call this somewhere to know if the tile has to be active
  // isTileAvailableForSpecialObjects(row, column)

  let tileStyle;
  const isCenterX = Math.round((columnNumber - 1) / 2);
  const isCenterY = Math.round((rowNumber - 1) / 2);

  const isActiveTile =
    multimode.active &&
    multimode.move &&
    multimode.tile &&
    row === multimode.tile.row &&
    column === multimode.tile.column
      ? classes.activeTile
      : multimode.active && multimode.unlimited
      ? ""
      : selectedTile?.row === row && selectedTile?.column === column
      ? classes.activeTile
      : "";

  const layerColor =
    currentLayout === "event"
      ? classes.finalBorderColorEvent
      : currentLayout === "theme"
      ? classes.finalBorderColorTheme
      : "";

  //multiselection background color check
  if (
    multimode.active &&
    multimode.isDelete &&
    tile.middle.type === "arcdetriomphe" &&
    currentLayout === "normal"
  ) {
    tileStyle = `${tileStyle} ${classes.desactivatedTile}`;
  } else if (
    multimode.active &&
    (multimode.unlimited || multimode.associateCoords)
  ) {
    tileStyle = `
    ${tileStyle}
    ${
      (multimode.associateCoords && isAvailable) ||
      (!multimode.associateCoords && tile.middle.type !== "spawn")
        ? classes.multimodeColor
        : isActiveTile && multimode.associateCoords
        ? classes.activeTile
        : classes.desactivatedTile
    }
    `;

    if (
      multimode?.tile &&
      Array.isArray(multimode.tile) &&
      multimode?.tile?.some(
        (item) => item?.row === row && item?.column === column
      )
    )
      tileStyle = `${tileStyle} ${classes.multimodeSelected}`;
  } else if (multimode.active) {
    tileStyle = `${tileStyle} ${
      !isAvailable && !isActiveTile
        ? classes.desactivatedTile
        : classes.multimodeColor
    } ${isActiveTile ? classes.activeTile : ""} `;
  }
  // Center tile style
  if (row === isCenterY && column === isCenterX)
    return `
      ${tileStyle}
      ${width >= 1024 ? classes.tileHover : ""}
      ${classes.tileCenterColor}
      ${layerColor}
      ${isActiveTile}
      `;

  // theme tile border color according to old version
  if (currentLayout === "event")
    tileStyle = `${tileStyle} ${classes.finalBorderColorEvent}`;
  else if (currentLayout === "theme")
    tileStyle = `${tileStyle} ${classes.finalBorderColorTheme}`;

  // Return all previous
  return `${tileStyle} ${
    width >= 1024 ? classes.tileHover : ""
  } ${isActiveTile}`;
}
